const CommonStartColumns = [
  {
    value: 'patient_name',
    label: 'Patient Name',
    width:'10rem'
  },
  {
    value: 'patient_id',
    label: 'Patient ID',
    width:'8rem'
  },
  {
    value: 'bi_case_id',
    label: 'BI Case ID',
    width:'8rem'
  },
];

const CommonColumnsForOffTherapy = [
  {
    value: '',
    label: 'Treatment Status',
    width:'20rem'
  },
  {
    value: 'reason_for_not_treating_patient',
    label: 'Reason for Not Treating Patient',
  },
  {
    value: 'bi_completed',
    label: 'BI Completed',
  },
];

export const PATIENT_NOT_RECEIVING_TREATMENT_HEADER_LISTING = [
  ...CommonStartColumns,
  {
    value: 'insurance_type',
    label: 'Insurance Type',
    width:'20rem'
  },
  {
    value: 'provider',
    label: 'Provider',
    width:'20rem'
  },
  ...CommonColumnsForOffTherapy,
  {
    value: '',
    label: 'Rerun',
    width:''
  },
];

export const PATIENT_NOT_RECEIVING_TREATMENT_MANUFACTURE_HEADER_LISTING = [
  ...CommonStartColumns,
  {
    value: 'payer',
    label: 'Payer',
    width:'20rem'
  },
  {
    value: 'provider',
    label: 'Provider',
    width:'20rem'
  },
  ...CommonColumnsForOffTherapy,
];




const CommonColumnsForOnTherapy = [
  {
    value: 'provider',
    label: 'Provider',
    width:'20rem'
  },
  {
    value: '',
    label: 'Treatment Status',
    width:'20rem'
  },
  {
    value: 'date_of_treatment',
    label: 'Date of Treatment',
    width:''
  },
  {
    value: 'date_of_next_treatment',
    label: 'Date of Next Treatment',
    width:''
  },
];

export const PATIENT_CURRENTLY_ON_TREATMENT_HEADER_LISTING = [
  ...CommonStartColumns,
  {
    value: 'insurance_type',
    label: 'Insurance Type',
    width:'20rem'
  },
  ...CommonColumnsForOnTherapy,
  {
    value: '',
    label: 'Rerun',
    width:''
  },
];

export const PATIENT_CURRENTLY_ON_TREATMENT_MANUFACTURE_HEADER_LISTING = [
  ...CommonStartColumns,
  {
    value: 'payer',
    label: 'Payer',
    width:'20rem'
  },
  ...CommonColumnsForOnTherapy,
];





export const CommonColumnsForPendingTreatment = [
  {
    value: 'provider',
    label: 'Provider',
    width:'20rem'
  },
  {
    value: '',
    label: 'Treatment Status',
    width:'20rem'
  },
  {
    value: 'bi_submitted',
    label: 'BI Submitted',
    width:''
  },
  {
    value: 'bi_completed',
    label: 'BI Completed',
    width:''
  },
];

export const PATIENT_PENDING_TREATMENT_HEADER_LISTING = [
  ...CommonStartColumns,
  {
    value: 'insurance_type',
    label: 'Insurance Type',
    width:'20rem'
  },
  ...CommonColumnsForPendingTreatment,
  {
    value: '',
    label: 'Rerun',
    width:''
  },
  {
    value: '',
    label: 'FAM/Office Note',
    width:''
  },
];

export const PATIENT_PENDING_TREATMENT_MANUFACTURE_HEADER_LISTING = [
  ...CommonStartColumns,
  {
    value: 'reverification',
    label: 'Case Type',
    width:''
  },
  {
    value: 'payer',
    label: 'Payer',
    width:'20rem'
  },
  ...CommonColumnsForPendingTreatment,
  {
    value: 'indication',
    label: 'Indication',
    width:''
  },
  // {
  //   value: '',
  //   label: 'Confirm Indication',
  //   width:''
   
  // },
  {
    value: '',
    label: 'FAM/Office Note',
    width:''
  },
];
